import styled from 'styled-components';

const Kuori = styled.div<{ $nakyy: boolean }>`
  position: fixed;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%);
  background: ${p => p.theme.color.ink};
  color: ${p => p.theme.color.onDark};
  padding: 12px 16px;
  border-radius: ${p => p.theme.radius.md};
  opacity: ${p => (p.$nakyy ? 1 : 0)};
  transition: opacity .25s;
  pointer-events: none;
  z-index: 40;
  max-width: min(90vw, 640px);
  text-align: center;
`;

export function Toast({ viesti }: { viesti: string | null }) {
  return <Kuori $nakyy={!!viesti} role="status" aria-live="polite">{viesti}</Kuori>;
}
